import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';

const generateAllDates = () => {
  const allDates = [];
  const today = new Date(); // 9 novembre 2024
  const dayNames = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
  const months = [
    'jan',
    'fév',
    'mar',
    'avr',
    'mai',
    'juin',
    'juil',
    'août',
    'sept',
    'oct',
    'nov',
    'déc'
  ];

  // 30 jours avant aujourd'hui
  // for (let i = 30; i >= 1; i--) {
  //   const pastDate = new Date(today);
  //   pastDate.setDate(today.getDate() - i);

  //   allDates.push({
  //     id: `past-${i}`,
  //     dateName: dayNames[pastDate.getDay()],
  //     dateDesc: `${pastDate.getDate()} ${months[pastDate.getMonth()]}`,
  //     isPast: true,
  //     isToday: false,
  //     isFuture: false
  //   });
  // }

  // Aujourd'hui
  allDates.push({
    id: 'today',
    dateName: "Aujourd'hui",
    dateDesc: `${today.getDate()} ${months[today.getMonth()]}`,
    isPast: false,
    isToday: true,
    isFuture: false
  });

  // 15 jours après aujourd'hui
  for (let i = 1; i <= 15; i++) {
    const futureDate = new Date(today);
    futureDate.setDate(today.getDate() + i);

    allDates.push({
      id: `future-${i}`,
      dateName: dayNames[futureDate.getDay()],
      dateDesc: `${futureDate.getDate()} ${months[futureDate.getMonth()]}`,
      isPast: false,
      isToday: false,
      isFuture: true
    });
  }

  return allDates;
};

export const EVENTS = {
  MATCH: {
    SH0W_ALL: 'match.show_all',
    SH0W_LIVE: 'match.show_live',
    LIST_ALL: {
      REFRESH: 'MATCH.LIST_ALL.REFRESH',
      REFRESHING: 'MATCH.LIST_ALL.REFRESHING',
      REFRESHED: 'MATCH.LIST_ALL.REFRESHED',
      REFRESH_ERROR: 'MATCH.LIST_ALL.REFRESH_ERROR'
    },
    LIVE: {
      REFRESH: 'MATCH.LIVE.REFRESH',
      REFRESHING: 'MATCH.LIVE.REFRESHING',
      REFRESHED: 'MATCH.LIVE.REFRESHED',
      REFRESH_ERROR: 'MATCH.LIVE.REFRESH_ERROR'
    },
    PRONOSTICS: {
      REFRESH: 'MATCH.PRONOSTICS.REFRESH',
      REFRESHING: 'MATCH.PRONOSTICS.REFRESHING',
      REFRESHED: 'MATCH.PRONOSTICS.REFRESHED',
      REFRESH_ERROR: 'MATCH.PRONOSTICS.REFRESH_ERROR'
    },
    SHOW_MATCH_DETAIL: 'match.SHOW_MATCH_DETAIL',
    SHOW_COMPETITION_DETAIL: 'match.SHOW_COMPETITION_DETAIL'
  }
};

export const ENDPOINTS = {
  MATCH: {
    GET_LIVE:
      'https://api.kingrecharges.com/match/fetch/matches/live?group=lacasae',
    GET_LIST:
      'https://api.kingrecharges.com/match/fetch/matches/upcoming?group=lacasae&nbDaysInFuture=',
    GET_PRONOSTICS:
      'https://api.kingrecharges.com/match/fetch/matches/upcoming?group=lacasae&nbDaysInFuture=0'
  }
};

export const MATCH = {
  LOTTIES: {
    EMPTY: emptyTransactions,
    LOADING_ERROR: loadingError
  },
  ALL_DATES: generateAllDates()
};
